import { createFileRoute, redirect } from "@tanstack/react-router";
import { PublicFormPage } from "@/features/formpublic/PublicFormPage";

/** The root answers the live form saved on this host when a custom domain has one (X21-MKT-04b), and the app's home otherwise.
 *  The server decides: a platform host never matches a verified custom domain, so it answers 404 and the visitor goes home. */
export const Route = createFileRoute("/")({
  beforeLoad: async () => {
    const token = await formTokenOnThisHost();
    if (!token) throw redirect({ to: "/home" });
    return { hostedFormToken: token };
  },
  component: HostedFormRoot,
});

/** GET /api/public/form-host: the token of the live form on this host, or null (no form, or the request failed). */
async function formTokenOnThisHost(): Promise<string | null> {
  try {
    const res = await fetch("/api/public/form-host", { credentials: "same-origin", headers: { accept: "application/json" } });
    if (!res.ok) return null;
    const body = (await res.json()) as { token?: unknown };
    return typeof body.token === "string" ? body.token : null;
  } catch {
    return null;
  }
}

function HostedFormRoot() {
  const { hostedFormToken } = Route.useRouteContext();
  return <PublicFormPage slug={hostedFormToken} />;
}
